import { IHsnProps } from './HsnSearch';
import { NoResultFound } from './NoResultFound';
import { IHsnDataCollection } from './Service/hsn.service';

type IDesktopProps = IHsnProps & { type: keyof IHsnDataCollection };

export const HsnSearchDesktop = ({
  results,
  type,
}: IDesktopProps): JSX.Element => (
  <div className="container mt-10 mx-auto sm:hidden">
    {Object.keys(results[type]).length ? (
      <table
        className="w-full text-sm text-left shadow-md border rounded-md text-gray-500 dark:text-gray-400 border-separate"
        style={{ borderSpacing: 0 }}
      >
        <thead className="text-xs text-gray-700  bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
          <tr>
            <th
              scope="col"
              className=" text-base font-light textable-cell text-font-200 py-2 px-4  bg-blue-50  rounded-tl-md"
            >
              Chapter
            </th>
            <th
              scope="col"
              className="text-base font-light textable-cell text-font-200 py-2 px-4  bg-blue-50"
            >
              Description
            </th>
            <th
              scope="col"
              className=" text-base font-light textable-cell text-font-200 py-2 px-4  bg-blue-50"
            >
              HSN Code
            </th>
            <th
              scope="col"
              className=" text-base font-light textable-cell text-font-200 py-2 px-4  bg-blue-50"
            >
              Rate (%)
            </th>
            <th
              scope="col"
              className=" text-base font-light textable-cell text-font-200 py-2 px-4  bg-blue-50"
            >
              CESS (%)
            </th>
            <th
              scope="col"
              className=" text-base font-light textable-cell text-font-200 py-2 px-2  bg-blue-50"
            >
              Effective Date
            </th>
            <th
              scope="col"
              className=" text-base font-light textable-cell text-font-200 py-2 pl-2  bg-blue-50"
            >
              Rate Revision
            </th>
          </tr>
        </thead>
        <tbody>
          {Object.keys(results[type]).map((e) => {
            const resultType = results[type][e];
            return resultType?.map((ele, index) => {
              return (
                <tr key={ele.hsnCode + index}>
                  {index == 0 ? (
                    <td
                      scope="row"
                      className="px-4 py-4 align-top w-1/4  font-semibold text-font-500 "
                      rowSpan={resultType?.length}
                    >
                      {ele.chapter}
                    </td>
                  ) : null}
                  <td
                    scope="row"
                    className="px-4 py-4 w-1/4  text-font-500 align-top "
                    dangerouslySetInnerHTML={{ __html: ele.description }}
                  ></td>
                  <td
                    scope="row"
                    className="px-4 py-4  font-semibold text-font-500 align-top "
                  >
                    {ele.hsnCode}
                  </td>
                  <td
                    scope="row"
                    className="px-4 py-4  text-font-500 align-top "
                  >
                    {ele.rate}
                  </td>

                  <td
                    scope="row"
                    className={`px-4 py-4 text-font-500 align-top ${
                      ele.cess ? '' : 'text-center'
                    }`}
                  >
                    {ele.cess ? ele.cess : '-'}
                  </td>
                  <td
                    scope="row"
                    className={`px-4 py-4 text-font-500 align-top`}
                  >
                    {ele.effectiveDate ? ele.effectiveDate : '-'}
                  </td>
                  <td
                    scope="row"
                    className={`px-4 py-4  font-semibold align-top text-font-500 ${
                      ele.rateRevision ? '' : 'text-center'
                    }`}
                  >
                    {ele.rateRevision ? ele.rateRevision : '-'}
                  </td>
                </tr>
              );
            });
          })}
        </tbody>
      </table>
    ) : (
      <NoResultFound
        height={'200'}
        width={'200'}
        texts={[
          'The HSN/SAC code or keyword you entered is not on record or is invalid.',
          'Please try with another HSN/SAC Code OR try changing the keywords.',
        ]}
      />
    )}
  </div>
);
